import { Sparkles } from "lucide-react"
import { Link } from "react-router-dom"

export function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="border-t border-border/70 bg-background text-foreground">
      <div className="container py-16">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-6">
              <div className="relative h-10 w-10 rounded-xl bg-gradient-to-br from-indigo-500 via-blue-500 to-cyan-400 shadow-[0_14px_40px_rgba(37,99,235,0.18)] flex items-center justify-center">
                <span className="text-base font-bold text-white">N</span>
                <Sparkles className="absolute -top-1 -right-1 h-4 w-4 text-amber-500 bg-white rounded-full p-[2px] shadow-sm ring-1 ring-slate-200" />
              </div>
              <span className="text-xl font-bold tracking-tight">Nestor</span>
            </Link>
            <p className="max-w-sm text-muted-foreground leading-relaxed">
              The modern operating system for your workforce. Designed for speed, clarity, and the future of work.
            </p>
          </div>

          <div>
            <h3 className="font-semibold mb-6">Product</h3>
            <ul className="space-y-4 text-muted-foreground">
              <li><Link className="hover:text-foreground transition-colors" to="/product">Overview</Link></li>
              <li><Link className="hover:text-foreground transition-colors" to="/product/core-hr">Core HR</Link></li>
              <li><Link className="hover:text-foreground transition-colors" to="/product/payroll">Payroll</Link></li>
              <li><Link className="hover:text-foreground transition-colors" to="/product/analytics">Analytics</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-6">Company</h3>
            <ul className="space-y-4 text-muted-foreground">
              <li><Link className="hover:text-foreground transition-colors" to="/about">About</Link></li>
              <li><Link className="hover:text-foreground transition-colors" to="/resources">Resources</Link></li>
              <li><Link className="hover:text-foreground transition-colors" to="/blog">Blog</Link></li>
              <li><Link className="hover:text-foreground transition-colors" to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-6">Legal</h3>
            <ul className="space-y-4 text-muted-foreground">
              <li><Link className="hover:text-foreground transition-colors" to="/privacy">Privacy Policy</Link></li>
              <li><Link className="hover:text-foreground transition-colors" to="/terms">Terms</Link></li>
              <li><Link className="hover:text-foreground transition-colors" to="/security">Security</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border/70 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <p>© {year} Nestor India. All rights reserved.</p>
          <div className="flex gap-8">
            <span>ISO 27001 Certified</span>
            <span>SOC 2 Type II</span>
            <span>GDPR Compliant</span>
          </div>
        </div>
      </div>
    </footer>
  )
}

